import { render, staticRenderFns } from "./HelpCenterContentItem.vue?vue&type=template&id=6ebab7e4&scoped=true&"
var script = {}
import style0 from "./HelpCenterContentItem.vue?vue&type=style&index=0&id=6ebab7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebab7e4",
  null
  
)

export default component.exports